module.exports = __webpack_public_path__ + "img/kr-product-final-card2-img2.b785db1.png";